/**
 * AGB code validation.
 *
 * AGB (Algemeen GegevensBeheer) codes are 8-digit identifiers for healthcare
 * providers, organisations and locations in the Netherlands. They are emitted
 * verbatim into VECOZO declaratie XML, so any deviation from the 8-digit format
 * breaks downstream processing.
 */
const AGB_CODE_PATTERN = /^\d{8}$/

/**
 * The same rule as a `pattern` attribute, for a field that wants the browser's own
 * constraint validation. Exported so a template binds it rather than writing the
 * regex out again: two `.vue` files had spelled it by hand, which is the copy
 * `billing:agb-format` exists to refuse (#4275).
 */
export const AGB_CODE_PATTERN_SOURCE = AGB_CODE_PATTERN.source

/**
 * @returns true if the value is empty or matches the 8-digit format. Empty
 * input is treated as "not provided" — nullability is enforced separately.
 */
export function isValidAgbCode(value: string | null | undefined): boolean {
  if (value == null || value === '') return true
  return AGB_CODE_PATTERN.test(value)
}

/**
 * The value with the separators a person types into an AGB code by hand ("94-012345",
 * "94 012345") stripped, for comparing two codes; empty when there is no value.
 */
export function normalizedAgbCode(value: string | null | undefined): string {
  return value?.replace(/[\s-]/g, '') ?? ''
}
